import { isArray, isObject } from 'lodash';

export class MandatoryValueProcessor {

  public static processMandatoryValues(mandatoryValuesArray, fieldValue, label) {
    let mandatoryValuesLabel;

    // the mandatoryValuesArray can only be applied to an object
    if (!fieldValue) {
      return;
    } else if (!isObject(fieldValue)) {
      return;
    }

    // mandatoryValuesArray must be an array
    if (!mandatoryValuesArray) {
      return;
    } else if (!isArray(mandatoryValuesArray)) {
      return;
    }

    for (let i = 0; i < mandatoryValuesArray.length; i++) {
      try {
        const matches = (<any>window).jsonpath.query(fieldValue, mandatoryValuesArray[i].jsonPathQuery);
        if (matches.length === 0) {
          if (!mandatoryValuesLabel) {
            mandatoryValuesLabel = label;
          }

          // the mandatoryValuesLabel is output to html so use, <br> for the break
          mandatoryValuesLabel += '<br> ➡ ' + mandatoryValuesArray[i].name;
        }
      } catch (err) {
        return err;
      }


    }

    return mandatoryValuesLabel;
  }

}
